<template>
  <div class="bg-click-catcher">
  </div>
</template>
<style scoped>
.bg-click-catcher {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  /* background-color: rgba(0, 0, 0, 0.4); */
  z-index: 3000;
}
</style>